(() => {
  const getDrawer = () => document.querySelector("cart-drawer");

  const closeDrawer = () => {
    const closeButton = getDrawer()?.querySelector(".drawer__close");
    closeButton && closeButton.click();
    window.setTimeout(() => {
      const productGrid =
        document.querySelector('[id*="featured_collection"] .product-grid') ||
        document.querySelector("#ProductGridContainer") ||
        document.querySelector(".product-grid");
      productGrid ?
        productGrid.scrollIntoView({behavior: "smooth", block: "start"}) :
        window.location.assign("/collections/frontpage?build=your-set");
    }, 180);
  };

  // Le bouton "Lanjut Belanja"  (.solea-aov__continue) est maintenant rendu
  // directement dans cart-drawer.liquid, a la suite de la liste de produits.
  // Plus besoin de le construire/injecter en JS -> plus de delai d'affichage,
  // il est present des le premier rendu de la page.
  //
  // On garde juste ce script pour brancher le clic. La delegation sur
  // document (plutot qu'un addEventListener direct sur le bouton) evite
  // d'avoir a ré-attacher l'ecouteur a chaque fois que Shopify re-rend le
  // panier (ajout/suppression d'article), puisque le bouton est recree a
  // chaque fois par le Liquid.
  document.addEventListener("click", event => {
    const button = event.target.closest(".solea-aov__continue");
    if (button) closeDrawer();
  });
})();

/*
  ---- Ancienne version (bouton injecte dynamiquement en JS) ----
  Gardee ici a titre de reference si jamais on doit revenir a un rendu
  cote client base sur cart.js (item_count, total_price, etc.) plutot que
  sur le Liquid cote serveur.

  (() => {
    const BLOCK_CLASS = "solea-aov";
    let refreshTimer, refreshing = false;

    const getDrawer = () => document.querySelector("cart-drawer");
    const getItemsContainer = () =>
      document.querySelector("#CartDrawer-CartItems") ||
      document.querySelector("cart-drawer .drawer__contents");

    const closeDrawer = () => { ... };

    const render = cart => {
      const itemsContainer = getItemsContainer();
      if (!itemsContainer || !cart?.item_count) return;
      const signature = `${cart.item_count}:${Math.round(cart.total_price / 100)}`;
      const existing = itemsContainer.querySelector(`.${BLOCK_CLASS}`);
      if (existing?.dataset.signature === signature) return;

      const block = document.createElement("div");
      block.className = BLOCK_CLASS;
      block.dataset.signature = signature;
      block.innerHTML = `<button type="button" class="solea-aov__continue">Lanjut Belanja</button>`;
      block.querySelector(".solea-aov__continue")?.addEventListener("click", closeDrawer);
      existing?.remove();
      itemsContainer.appendChild(block);
    };

    const refresh = async () => {
      const drawer = getDrawer();
      if (!drawer || refreshing) return;
      refreshing = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
          credentials: "same-origin", headers: { Accept: "application/json" }
        });
        if (response.ok) render(await response.json());
      } catch (error) {
        console.warn("[Solea AOV] Cart enhancement unavailable.", error);
      } finally {
        refreshing = false;
      }
    };

    const scheduleRefresh = () => {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refresh, 120);
    };

    document.addEventListener("DOMContentLoaded", () => {
      const drawer = getDrawer();
      if (drawer) {
        new MutationObserver(scheduleRefresh).observe(drawer, {
          attributes: true, attributeFilter: ["class"], childList: true, subtree: true
        });
        scheduleRefresh();
      }
    });
  })();
*/